export function loading (state) {
  return state.loading
}
